import { render, staticRenderFns } from "./addChangeBatch.vue?vue&type=template&id=a6baf0be&scoped=true"
import script from "./addChangeBatch.vue?vue&type=script&lang=js"
export * from "./addChangeBatch.vue?vue&type=script&lang=js"
import style0 from "./addChangeBatch.vue?vue&type=style&index=0&id=a6baf0be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6baf0be",
  null
  
)

export default component.exports